import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalForUpdateUser from './ModalForUpdateUser';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import Tooltip from '@mui/material/Tooltip';
import { ConfirmDialog, Tooltips } from '../../enums/UserEnums';
import { TableCell, TableRow } from '@mui/material';

const SUPER_ADMIN_ROLE = 'SUPER_ADMIN';

const UserRow = ({
  clearValidationErrors,
  dispatch,
  updateUser,
  deactivateUser,
  activateUser,
  user,
  userReducer,
  userRoleReducer,
  loggedUser,
}) => {
  const [show, setShow] = useState(false);
  const isSuperAdmin = loggedUser?.role?.roleName === SUPER_ADMIN_ROLE;

  const showModal = (e) => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (user) => {
    dispatch(updateUser(user, handlePreviewClose));
  };

  const onDeactivateClick = (id) => {
    const action = () => {
      dispatch(deactivateUser(id));
    };
    confirmDialog(
      ConfirmDialog.deactivateUserMessage,
      action,
      ConfirmDialog.deactivate
    );
  };

  const onActivateClick = (id) => {
    const action = () => {
      dispatch(activateUser(id));
    };
    confirmDialog(
      ConfirmDialog.activateUserMessage,
      action,
      ConfirmDialog.activate
    );
  };

  const activateDeactivateUser = (id, onClick, title, iconClassName) => {
    return (
      <TableCell className="text-center">
        <Link to="#" id={id} onClick={onClick}>
          <Tooltip title={title} placement="top" arrow="true">
            <i className={iconClassName} />
          </Tooltip>
        </Link>
      </TableCell>
    );
  };

  const iActivateDeactivateClassName = user.active
    ? 'fas fa-check'
    : 'fas fa-times';

  let row = (
    <TableRow>
      <TableCell>{user.firstName}</TableCell>
      <TableCell>{user.lastName}</TableCell>
      <TableCell>{user.username}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.address}</TableCell>
      <TableCell>{user.phoneNumber}</TableCell>
      <TableCell>{user.role.roleName}</TableCell>
      {isSuperAdmin && (
        <TableCell>{user.company?.companyName}</TableCell>
      )}
      <TableCell className="text-center">
        <i className={iActivateDeactivateClassName}></i>
      </TableCell>
      {user.active
        ? activateDeactivateUser(
            'dectivateUser',
            () => onDeactivateClick(user.id),
            Tooltips.deactivate,
            'fas fa-times-circle fa-2x'
          )
        : activateDeactivateUser(
            'ctivateUser',
            () => onActivateClick(user.id),
            Tooltips.activate,
            'fas fa-play-circle fa-2x'
          )}
      <TableCell className="text-center" id="centerRow">
        <Link
          to="#"
          onClick={(e) => {
            showModal();
          }}
        >
          <i className="fas fa-edit fa-2x" />
        </Link>
      </TableCell>
    </TableRow>
  );

  return (
    <>
      {row}
      {show && (
        <ModalForUpdateUser
          show={show}
          user={user}
          userReducer={userReducer}
          userRoleReducer={userRoleReducer}
          handleEdit={handleEdit}
          handleClose={handlePreviewClose}
          clearValidationErrors={clearValidationErrors}
          userId={user.id}
        />
      )}
    </>
  );
};

export default UserRow;